<template>
    <fieldset
        class="mt-2 mb-3 avoid-page-break-inside"
        data-test-role="equipment-item-div">
        <!-- So far, assume Battery -->
        <legend class="h6 mb-0">
            <span class="d-inline-flex align-items-baseline col-12 col-lg-9 mb-0">
                <div class="mb-2">
                    {{ batterySectionLabel }}
                    <pc-button
                        v-bind:disabled="readonly"
                        class="mx-4 p-0 border-0"
                        style="line-height: inherit"
                        data-test-role="delete-equipment-item"
                        link
                        v-on:click="onDelete">
                        {{ deleteBatteryButtonText }}
                    </pc-button>
                </div>
            </span>
        </legend>
        <model-picker
            ref="modelPicker"
            class="mb-2"
            v-bind:manufacturers="equipmentManufacturers"
            v-bind:load-models="loadEquipmentModels"
            v-bind:spec="equipmentItem"
            v-bind:parent-id="parentId"
            v-bind:equipment-type="equipmentType"
            v-bind:can-copy="canCopy"
            v-bind:readonly="readonly"
            v-on:copy-component="onCopyEquipmentGroupClicked" />
    </fieldset>
</template>

<script>
    import modelPicker from "./modelPicker.vue";
    import { SLIDE_DOWN_UP } from "Util/animations";
    import { mapI18n } from "Util/i18n";
    import { KEYS, NAMESPACE } from "./equipmentgroup.i18n";
    import { extendEquipmentManufList, extendEquipmentModelList } from "../equipment/equipmentUtil";
    import { COMPONENT_TYPE } from "Types/componentTypes";
    import { getResponsiveClassMap } from "Responsive/manager";

    const responsiveConfig = {
        equipmentRatingLabel: {
            // col-auto col-xl-12 d-inline d-xl-flex
            col: { xs: "auto", xl: 12 },
            d: { xs: "inline", xl: "flex" }
        }
    };

    export default {
        components: { modelPicker },
        inject: {
            pvSystemElement: {
                from: "pvSystemElement"
            },
            viewport: {
                from: "viewport",
                default: null
            }
        },
        props: {
            equipmentItem: { type: Object, required: true },
            parentId: { type: String, required: true },
            canCopy: { type: Boolean, required: true },
            readonly: { type: Boolean, required: false, default: false }
        },
        emits: ["copy-equipmentgroup"],
        data() {
            return {
                // Assume Battery for now
                equipmentType: COMPONENT_TYPE.Battery,
                equipmentModels: [],
                modelsLoading: false
            };
        },
        computed: {
            hasEquipmentModel() {
                return Boolean(this.equipmentItem.modelId);
            },
            equipmentManufacturers() {
                const eqManufList = this.$serviceControllers.PvSystem.getEquipmentManufacturers(this.equipmentType);

                if (this.equipmentItem && this.equipmentItem.manufacturerId) {
                    const clearManufId = extendEquipmentManufList(
                        eqManufList,
                        this.equipmentItem.manufacturerId,
                        this.pvSystemElement.projectElement.AuxiliaryModel.storedEquipmentModels
                    );

                    if (clearManufId) {
                        this.pvSystemElement.setEquipmentItemProperty({
                            subsystemId: this.parentId,
                            equipmentItemId: this.equipmentItem.id,
                            name: "manufacturerId",
                            value: ""
                        });
                    }
                }

                return eqManufList;
            },
            responsiveClasses() {
                return getResponsiveClassMap(this.viewport, responsiveConfig);
            },
            ...mapI18n(
                {
                    ...KEYS
                },
                NAMESPACE
            )
        },
        watch: {},
        methods: {
            validate() {
                return false;
            },
            onValidated(prop, validationResult) {
                this.validationResults[prop] = validationResult;
            },
            onDelete() {
                this.pvSystemElement.deleteEquipmentItem({
                    subsystemId: this.parentId,
                    equipmentItemId: this.equipmentItem.id
                });
            },
            async loadEquipmentModels(equipmentType, manufacturerName) {
                const equipmentModelList =
                    (await this.$serviceControllers.PvSystem.getEquipmentModels(equipmentType, manufacturerName)) || [];

                if (this.equipmentItem && this.equipmentItem.modelId) {
                    extendEquipmentModelList(
                        equipmentModelList,
                        this.equipmentItem.modelId,
                        this.pvSystemElement.projectElement.AuxiliaryModel.storedEquipmentModels,
                        this.updatedModelSuffix
                    );
                }

                this.equipmentModels = equipmentModelList;

                return this.equipmentModels;
            },
            async onCopyEquipmentGroupClicked() {
                await this.$emit("copy-equipmentgroup", this.equipmentItem.id);
            },
            focusEquipmentGroupInput() {
                this.$refs.modelPicker.setFocusToQuantityInput();
            },
            enter: SLIDE_DOWN_UP.enter,
            leave: SLIDE_DOWN_UP.leave
        }
    };
</script>
